

<script>
import { Pie } from 'vue-chartjs'
import { setTimeout } from 'timers';
export default {
  extends: Pie,
  data() {
      return {
          compageview:0,
          copageview:0,
          rupageview:0,
          piedata:[]
      }
  },
  mounted () {
         this.setData()
    this.renderChart({
      labels: ['onedio.com','onedio.co','onedio.ru'],
      datasets: [
        {
          backgroundColor: [
            '#20a8d8',
            '#ffc107',
            '#4dbd74'
          ],
          data:this.piedata
        }
      ]
    }, {responsive: true, maintainAspectRatio: true})
  },
  methods: {
     async setData(){
        this.compageview=parseInt(this.$store.state.comPageview.replace(/\./g,""))
        this.copageview=parseInt(this.$store.state.coPageview.replace(/\./g,""))
        this.rupageview=parseInt(this.$store.state.ruPageview.replace(/\./g,""))
        this.piedata.push(this.compageview)
        this.piedata.push(this.copageview)
        this.piedata.push(this.rupageview)
      }
  },
}
</script>
